import {Heading} from '@primer/react'
import {Pagehead} from '@primer/react/deprecated'
import type {FC, ReactNode} from 'react'
import {clsx} from 'clsx'
import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import styles from './PanelHeader.module.css'

interface PanelHeaderProps {
  title: string
  subtitle?: string
  as?: 'h2' | 'h3'
  trailing?: ReactNode
}

export const PanelHeader: FC<PanelHeaderProps> = ({title, subtitle, as = 'h2', trailing}) => {
  const rulesImprovedPanelHeader = useFeatureFlag('rules_improved_panel_header')

  return (
    <>
      {rulesImprovedPanelHeader ? (
        <>
          <div className="d-flex">
            <Heading as={as} className={`${as === 'h2' ? 'f2 text-normal' : 'f3 text-normal'}`}>
              {title}
            </Heading>
            {trailing}
          </div>
          {subtitle ? <span className="fgColor-muted">{subtitle}</span> : null}
        </>
      ) : (
        <>
          <Pagehead as="h2" className={clsx('h2-override-shared-component', styles.PanelHeaderPagehead)}>
            {title}
          </Pagehead>
          <span className={styles.PanelHeaderSubtitle}>{subtitle}</span>
        </>
      )}
    </>
  )
}

try{ PanelHeader.displayName ||= 'PanelHeader' } catch {}